import styled from "styled-components";

export const Main = styled.div`
   width: 150px;
   padding: 0;
`;

export const Styled = styled.div`
   .select {
      &:not(:last-of-type) {
         margin-bottom: 10px;
      }
      h4 { 
         width: 80px; 
      }
   }
   
   .textInput {
      h4 {
         width: 100px;
         white-space: nowrap;
         overflow: hidden;
         text-overflow: ellipsis;
      }
   }
   
   > .scroll {
      overflow: auto;
      max-height: 280px;
      padding-right: 10px;
      margin-top: 10px;
      padding-top: 10px;
      border-top: 1px solid rgba(200, 200, 200, 0.3);
   }
   
   .authSelect {
      margin-bottom: 16px;
   }
   
   .keyTypeSelect {
      margin-bottom: 12px;
      
      label {
         display: block;
         font-size: 0.85rem;
         color: #666;
         margin-bottom: 4px;
      }
      
      select {
         width: 100%;
         padding: 8px 10px;
         border-radius: 6px;
         border: 1px solid #ccc;
         font-size: 0.9rem;
         background: #fff;
      }
   }

   .agent-decide-info {
      display: flex;
      gap: 10px;
      padding: 12px;
      margin-top: 10px;
      background: linear-gradient(135deg, #f0f7ff, #e8f4fd);
      border: 1px solid #bde0fe;
      border-radius: 10px;
      align-items: flex-start;

      .agent-icon {
         font-size: 22px;
         line-height: 1;
         flex-shrink: 0;
         margin-top: 2px;
      }

      .agent-text {
         strong {
            font-size: 13px;
            color: #1a56db;
            display: block;
            margin-bottom: 4px;
         }
         p {
            font-size: 11.5px;
            color: #4b6fa0;
            line-height: 1.45;
            margin: 0;
         }
      }
   }
`;